import { SET_AUTH, CLEAR_AUTH } from "../actions/authAction";

const initialState = {
  username: null,
  groups: [],
  permissions: [],
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH:
      return {
        ...state,
        username: action.payload.username,
        groups: action.payload.groups,
        permissions: action.payload.permissions, // TODO: Develop permissions later
      };
    case CLEAR_AUTH:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
